export enum SurveyRespondentType {
  /**
   * A new survey respondent will be created upon initialisation
   */
  New,
  /**
   * An existing survey respondent will be used for initialisation
   */
  Existing,
  /**
   * The questionnaire will have an anonymous respondent
   */
  Anonymous,
}
